import { motion } from "framer-motion";
import { Btn } from "../Bits";
import { useSite } from "../../context/SiteContext";
import { IMAGES } from "../../lib/images";

const Hero = () => {
  const { settings } = useSite();
  const hero = settings?.hero;

  return (
    <section data-testid="home-hero" className="relative overflow-hidden bg-white">
      <div className="mako-grid-bg absolute inset-0 opacity-70" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-[1400px] gap-14 px-6 pb-16 pt-14 lg:grid-cols-12 lg:gap-10 lg:px-10 lg:pb-28 lg:pt-24">
        <div className="lg:col-span-6 lg:pt-6">
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mako-label text-[#0F4C81]"
          >
            {hero?.eyebrow || "MAKO COMBAT SURFACES"}
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 22 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
            className="mt-7 font-display text-4xl font-bold uppercase leading-[0.98] tracking-[-0.02em] text-[#111111] sm:text-5xl lg:text-[4.15rem]"
          >
            {hero?.headline_1 || "Professional combat surfaces"}
            <span className="mt-2 block text-[#3B3B3B]">
              {hero?.headline_2 || "built for serious training"}
            </span>
          </motion.h1>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.6 }}
            className="mt-9 h-[2px] w-40 bg-[#0F4C81] mako-animate-line"
          />

          <motion.p
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.22 }}
            className="mt-9 max-w-xl text-sm leading-relaxed text-[#3B3B3B] sm:text-base"
          >
            {hero?.subcopy ||
              "Premium puzzle mats, tatami tiles, rollout mats and protective wall pads for MMA, BJJ, wrestling, judo and modern combat facilities."}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.34 }}
            className="mt-11 flex flex-col gap-3 sm:flex-row"
          >
            <Btn to="/mats" data-testid="hero-explore-cta">
              Explore the range
            </Btn>
            <Btn to="/contact" variant="outline" data-testid="hero-quote-cta">
              Request a quote
            </Btn>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.7, duration: 0.8 }}
            className="mako-tagline mt-12 text-[0.625rem] text-[#7A7F85] sm:text-xs lg:mt-16"
          >
            Built for impact.
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="relative lg:col-span-6"
        >
          <div className="relative aspect-[4/3] overflow-hidden bg-[#F5F5F2] sm:aspect-[5/4] lg:aspect-[4/5]">
            <img
              src={hero?.image || IMAGES.hero_facility}
              alt="Modern combat training facility with a professional MAKO mat surface"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-x-0 bottom-0 h-[3px] bg-[#0F4C81]" />
          </div>
          <div className="absolute -left-6 bottom-10 hidden bg-white px-6 py-5 shadow-[0_1px_0_0_rgba(17,17,17,0.08)] lg:block">
            <p className="mako-label text-[#7A7F85]">Surface system</p>
            <p className="mt-2 font-display text-sm font-semibold text-[#111111]">
              Mats · Wall pads · Custom
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
